import Vue from 'vue'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify)

const opts = {
  theme: { 
    dark: true,
    themes: {
      dark: {
        black: "#FFFFFF",
        orange: "#ffa500",
        yellow: "#FDD835",
        blue: "#a97afd",
        green: "#4CAF50",
        red: "#F44336",
        purple: "#9C27B0",
        grey: {
          darken2: "#9E9E9E"
        }
      }
    },
   },
}


export default new Vuetify(opts,{
  icons: {
    iconfont: 'mdi',
  },
})



// WEBPACK FOOTER //
// ./src/plugins/vuetify.js